import { useMemo, useState } from "react";
import { useQuery } from "react-query";
import { Card, CardBody, CardHeader, Col, FormGroup, Input, Label, Row } from "reactstrap";
import apiService from "services/api";
import { NakedTable } from "components";

const columns = [
  {
    id: "rank",
    header: "Rank",
    alignment: "center",
    width: 60,
    accessor: (row) => `#${row.rank}`,
  },
  {
    id: "lesson",
    header: "Lesson Topic",
    accessor: (row) => row.lessonName || "-",
  },
  {
    id: "course",
    header: "Course",
    accessor: (row) => row.courseName || "-",
  },
  {
    id: "past_week",
    header: "Past Week",
    alignment: "center",
    accessor: (row) => row.countPastWeek,
  },
  {
    id: "past_two_weeks",
    header: "Past 2 Weeks",
    alignment: "center",
    accessor: (row) => row.countPastTwoWeeks,
  },
  {
    id: "past_month",
    header: "Past Month",
    alignment: "center",
    accessor: (row) => row.countPastMonth,
  },
  {
    id: "past_three_months",
    header: "Past 3 Months",
    alignment: "center",
    accessor: (row) => row.countPastThreeMonths,
  },
];

const TopicFrequencyPage = () => {
  const [threshold, setThreshold] = useState(5);

  const { data, isLoading } = useQuery(
    ["lessonRecord", "topicFrequency", threshold],
    () => apiService.lessonRecord.topicFrequency({ threshold }),
    { keepPreviousData: true },
  );

  const visibleItems = useMemo(() => data?.items ?? [], [data]);

  return (
    <div className="content">
      <Card>
        <CardHeader className="d-flex justify-content-between align-items-start flex-wrap">
          <div>
            <h4 className="title mb-1">Lesson Topic Teaching Frequency</h4>
          </div>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="text-muted text-center py-4">Loading…</div>
          ) : (
            <NakedTable columns={columns} data={visibleItems} maxHeight="60vh" />
          )}
        </CardBody>
      </Card>
    </div>
  );
};

export default TopicFrequencyPage;
